





































































































































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { CalendarIcon, PlusIcon } from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import {
  DamageModel,
  DamageRegulationType,
  ICustomerAutocompleteOption,
  ITag,
  ITask,
  TagCategory,
} from 'admiral-core';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import { TagApi } from '@/services/TagApi';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import FormDateInput from '@/components/common/forms/FormDateInput.vue';
import ProductSelect from '@/components/common/selects/ProductSelect.vue';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import FormError from '@/components/common/forms/FormError.vue';
import UploadFiles from '@/components/common/UploadFiles.vue';
import DamageStatusSelect from '@/components/common/selects/DamageStatusSelect.vue';
import CommentBox from '@/components/common/CommentBox.vue';

import { DamageApi } from '@/services/DamageApi';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { CustomerApi } from '@/services/CustomerApi';
import { PolicyApi } from '@/services/PolicyApi';
import Checklist from '@/views/pages/checklists/Checklist.vue';
import CreateTaskModal from '@/views/pages/tasks/CreateTaskModal.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import FlixcheckPolicyChecksOverview from '@/components/integrations/flixcheck/FlixcheckPolicyChecksOverview.vue';

@Component({
  components: {
    Checklist,
    CreateTaskModal,
    UploadFiles,
    FormError,
    TagSelect,
    AdmiralCheckbox,
    FormDateInput,
    ProductSelect,
    FormInput,
    FormRow,
    FormTextarea,
    CalendarIcon,
    PlusIcon,
    Multiselect,
    UserSelect,
    DamageStatusSelect,
    CommentBox,
    FlixcheckPolicyChecksOverview,
  },
})
export default class DamageForm extends mixins(BaseMixin, PermissionMixin) {
  DamageRegulationType = DamageRegulationType;

  @Prop({ required: true })
  value!: DamageModel;

  @Prop({ required: true, type: Object })
  readonly errors!: keyof DamageModel;

  @Prop({ type: String, default: 'create' })
  readonly mode!: 'create' | 'edit';

  tags: ITag[] = [];
  customerNames: string[] = [];
  crmCustomerOptions: ICustomerAutocompleteOption[] = [];

  get useCrmCustomers(): boolean {
    return this.hasAgencyPermission('customers');
  }

  get customerNameOptions(): string[] {
    if (this.useCrmCustomers) {
      return this.crmCustomerOptions.map((option) => option.name);
    }
    return this.customerNames;
  }

  get crmCustomerFieldHint(): 'address' | 'new' | null {
    if (!this.useCrmCustomers) {
      return null;
    }
    const input = this.value.customer?.trim();
    if (!input) {
      return null;
    }
    if (this.findCrmCustomerOption(input)) {
      return this.selectedCrmCustomerAddress ? 'address' : null;
    }
    return 'new';
  }

  get selectedCrmCustomerAddress(): { street?: string; cityLine?: string } | null {
    const input = this.value.customer?.trim();
    if (!input) {
      return null;
    }
    const match = this.findCrmCustomerOption(input);
    if (!match) {
      return null;
    }
    const cityLine = [match.zip, match.city].filter(Boolean).join(' ');
    if (!match.street && !cityLine) {
      return null;
    }
    return {
      street: match.street,
      cityLine: cityLine || undefined,
    };
  }

  findCrmCustomerOption(input: string): ICustomerAutocompleteOption | undefined {
    const normalized = this.normalizeCustomerName(input);
    return this.crmCustomerOptions.find(
      (option) => this.normalizeCustomerName(option.name) === normalized,
    );
  }

  normalizeCustomerName(name: string): string {
    return name.trim().toLowerCase().replace(/\s+/g, ' ');
  }

  async mounted() {
    await this.loadTags();
    await this.loadCustomers();
  }

  onInput(key: string, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }
  onErrorReset(key: string) {
    this.$emit('reset-error', key);
  }

  get TAG_CATEGORY_DAMAGES() {
    return TagCategory.Damages;
  }

  async loadTags() {
    try {
      const response = await TagApi.getTags({
        category: TagCategory.Damages,
      });
      this.tags = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  async loadCustomers() {
    try {
      if (this.useCrmCustomers) {
        const response = await CustomerApi.getDisplayNames({ agency: this.agency });
        this.crmCustomerOptions = response.data || [];
        return;
      }
      const [dmg, pol] = await Promise.allSettled([
        DamageApi.getDamagesCustomerNames(this.agency),
        PolicyApi.getCustomerNames(this.agency),
      ]);
      const d = dmg.status === 'fulfilled' ? dmg.value.data : [];
      const p = pol.status === 'fulfilled' ? pol.value.data : [];
      this.customerNames = Array.from(new Set([...d, ...p]));
    } catch (e) {
      console.log(e);
    }
  }

  canValidate() {
    return this.hasAgencyPermission('llm-validate');
  }

  canFlixcheck() {
    return this.hasAgencyPermission('flixcheck');
  }

  async validateDamage() {
    try {
      const response = await DamageApi.validate(this.value!.id!);
    } catch (e) {
      console.log(e);
    }
  }

  deletedTask(task: ITask) {
    const tasks = this.value.tasks?.filter((t: ITask) => t.id !== task.id);
    this.onInput('tasks', tasks);
  }

  updatedTasks(task: ITask) {
    const tasks = [...(this.value.tasks || [])];
    for (let i = 0; i < tasks.length; i++) {
      if (this.value.tasks && tasks[i].id === task.id) {
        tasks[i] = task;
      }
    }
    this.onInput('tasks', [...tasks]);
  }

  createdTask(task: ITask) {
    this.onInput('tasks', [...(this.value.tasks || []), task]);
  }
}
